import { render, staticRenderFns } from "./details.vue?vue&type=template&id=6915f59f&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import "./details.vue?vue&type=style&index=0&id=6915f59f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915f59f",
  null
  
)

export default component.exports